import EmailTemplates from "layouts/settings/EmailTemplates";
import ProtectedRoute from "routes/protectedRoutes.js";

const SettingsRoutes = [
  {    
        route: "/admin/emailTemplates/:pageNo",
        key: "manage-emailTemplates",
        component: <ProtectedRoute check="logout"><EmailTemplates /></ProtectedRoute>  
  },
  ];

export default SettingsRoutes;